import { plaintextValidator, strictUrlValidator } from '../fields';

const config = {};

const validationObj = {
  url: strictUrlValidator,
  plainText: plaintextValidator
};
export default function dynamicFieldConstraints(arg) {
  if (Array.isArray(arg)) {
    return arg.reduce((acc, curr) => {
      switch (typeof curr) {
        case 'string':
          acc[curr] = plaintextValidator({ mandatory: true });
          break;
        case 'object':
          const isFun = validationObj[curr?.validationType] instanceof Function;
          acc[curr.name] = isFun
            ? validationObj[curr.validationType]({
                mandatory: true,
                customError: curr?.message ? `^ ${curr?.message}` : null
              })
            : plaintextValidator({
                mandatory: true,
                customError: curr?.message ? `^ ${curr?.message}` : null
              });
          break;
        default:
          acc[curr] = plaintextValidator({ mandatory: true });
          break;
      }
      return acc;
    }, {});
  }
  if (typeof arg === 'string') {
    return { [arg]: plaintextValidator({ mandatory: true }) };
  }
}
